import Cookies from "js-cookie";
import { createActionType, createAsyncAction } from "./create-actions";

export const ADD_USEFUL_LINK = createActionType("ADD_USEFUL_LINK");
export const GET_USEFUL_LINKS = createActionType("GET_USEFUL_LINKS");
export const EDIT_USEFUL_LINK_BY_ID = createActionType(
  "EDIT_USEFUL_LINK_BY_ID"
);
export const REMOVE_USEFUL_LINK_BY_ID = createActionType(
  "REMOVE_USEFUL_LINK_BY_ID"
);

export const addUsefulLink = (data: any) =>
  createAsyncAction(
    ADD_USEFUL_LINK,
    "/useful_links/add_useful_link",
    "post",
    data,
    {
      Authorization: `Bearer ${Cookies.get("token")}`,
    }
  );

export const getUsefulLinks = () =>
  createAsyncAction(
    GET_USEFUL_LINKS,
    "/useful_links/get_useful_links",
    "get",
    undefined
  );

export const editUsefulLink = (id: any, data: any) =>
  createAsyncAction(
    EDIT_USEFUL_LINK_BY_ID,
    `/useful_links/edit_useful_link_by_id/${id}`,
    "put",
    data,
    {
      Authorization: `Bearer ${Cookies.get("token")}`,
    }
  );

export const removeUsefulLink = (data: any) =>
  createAsyncAction(
    REMOVE_USEFUL_LINK_BY_ID,
    `/useful_links/remove_useful_link_by_id/${data}`,
    "delete",
    undefined,
    {
      Authorization: `Bearer ${Cookies.get("token")}`,
    }
  );
